const pad = (value) => String(value).padStart(2, "0")

export const normalizeCuit = (value) => {
  return String(value || "").replace(/\D/g, "")
}

export const isValidCuit = (value) => {
  const digits = normalizeCuit(value)

  if (digits.length !== 11) return false

  const weights = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2]
  const checkDigit = Number(digits[10])

  const total = weights.reduce((acc, weight, index) => {
    return acc + Number(digits[index]) * weight
  }, 0)

  const remainder = total % 11
  const verifier = remainder === 0 ? 0 : remainder === 1 ? 9 : 11 - remainder

  return verifier === checkDigit
}

export const getTodayInputDate = () => {
  const now = new Date()
  const year = now.getFullYear()
  const month = pad(now.getMonth() + 1)
  const day = pad(now.getDate())

  return `${year}-${month}-${day}`
}

export const formatDateForInput = (dateValue) => {
  if (!dateValue) return ""

  const normalizedString = String(dateValue)

  if (/^\d{4}-\d{2}-\d{2}$/.test(normalizedString)) {
    return normalizedString
  }

  if (/^\d{4}\/\d{2}\/\d{2}$/.test(normalizedString)) {
    return normalizedString.replace(/\//g, "-")
  }

  const parsedDate = new Date(dateValue)

  if (Number.isNaN(parsedDate.getTime())) {
    return normalizedString.slice(0, 10).replace(/\//g, "-")
  }

  const year = parsedDate.getFullYear()
  const month = pad(parsedDate.getMonth() + 1)
  const day = pad(parsedDate.getDate())

  return `${year}-${month}-${day}`
}

export const formatDateForApi = (dateValue) => {
  if (!dateValue) return null
  console.log(formatDateForInput(dateValue))
  return formatDateForInput(dateValue)
}

export const normalizeApiError = (error) => {
  const apiMessage = error?.response?.data?.message
  const apiCodeMessage = error?.response?.data?.codeMessageLanguage
  const apiStatus = error?.response?.data?.status

  if (apiMessage) return apiMessage
  if (apiCodeMessage) return apiCodeMessage
  if (apiStatus) return apiStatus
  if (error?.message) return error.message

  return "Ocurrió un error inesperado"
}

export const getAccessStatusCode = (item) => {
  if (!item) return ""

  return (
    item?.orgAppAccessStatusCode ||
    item?.userAppAccessStatusCode ||
    item?.accessStatusCode ||
    ""
  )
}

export const getAccessFinishDate = (item) => {
  if (!item) return null

  return item?.accessFinishDate || item?.finishDate || null
}

export const isCurrentOrFutureDate = (dateValue) => {
  if (!dateValue) return true

  const target = new Date(`${formatDateForInput(dateValue)}T00:00:00`)
  const today = new Date(`${getTodayInputDate()}T00:00:00`)

  return target.getTime() >= today.getTime()
}

export const isSameDate = (leftDate, rightDate) => {
  return formatDateForInput(leftDate) === formatDateForInput(rightDate)
}

export const isAccessGrantedAndActive = (item) => {
  if (!item) return false
  const statusCode = getAccessStatusCode(item)
  const finishDate = getAccessFinishDate(item)

  if (statusCode !== "GRANTED") return false
  if (!finishDate) return true
  const finish = new Date(`${formatDateForInput(finishDate)}T00:00:00`)
  const today = new Date(`${getTodayInputDate()}T00:00:00`)
  return finish.getTime() >= today.getTime()
}

export const pickBestApplicationInstance = (instances = []) => {
  if (!Array.isArray(instances) || !instances.length) return null

  const activeGrantedInstance = instances.find((instance) =>
    isAccessGrantedAndActive(instance),
  )

  if (activeGrantedInstance) return activeGrantedInstance

  const grantedInstance = instances.find(
    (instance) => getAccessStatusCode(instance) === "GRANTED",
  )

  return grantedInstance || instances[0] || null
}

export const extractGrantedRoleCodes = (payload, userId) => {
  const roleCodes = []

  if (
    !Array.isArray(payload?.applicationInstances) ||
    !payload?.applicationInstances[0]
  )
    return []

  payload.applicationInstances[0].appRoles.forEach((role) => {
    if (role && !roleCodes.includes(role.appRole)) {
      roleCodes.push(role.appRole)
    }
  })

  return Array.from(new Set(roleCodes))
}
export const shouldUpdateAccess = ({
  currentStatusCode,
  currentFinishDate,
  nextFinishDate,
}) => {
  if (currentStatusCode !== "GRANTED") return true
  if (!currentFinishDate && nextFinishDate) return true
  if (
    currentFinishDate &&
    nextFinishDate &&
    !isSameDate(currentFinishDate, nextFinishDate)
  )
    return true

  return false
}

export const buildUserDisplayName = (user) => {
  const firstName = user?.account?.firstName || ""
  const lastName = user?.account?.lastName || ""
  const fullName = `${firstName} ${lastName}`.trim()

  return fullName || user?.account?.email || user?.userId || "-"
}
